import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../shared/_services/auth.service';

@Component({
	selector: 'app-change-language',
	standalone: true,
	imports: [NgSelectModule, FormsModule],
	templateUrl: './change-language.component.html',
})
export class ChangeLanguageComponent {
	selectedLang: string = '';

	languages = [
		{ code: 'it', flag: 'it' },
		{ code: 'en', flag: 'gb' },
	];

	constructor(
		private translateService: TranslateService,
		private authService: AuthService,
	) {
		this.selectedLang = this.translateService.currentLang;
	}

	ngOnInit() {
		this.selectedLang = this.authService.getLingua()?? 'it';
	}

	changeLanguage(langCode: { code: string, flag: string }) {
		this.selectedLang = langCode.code;
		this.authService.setLingua(langCode.code);
		this.reloadPage();
	}

	reloadPage() {
		setTimeout(() => {
			window.location.reload();
		}, 100);
	}
}
